interface DynamicPayload {
          device_type: string;
          device_name: string;
          ip_address: string | null;
          browser: string;
          os_type: string;
          latitude: number | null|string;
          longitude: number | null|string;
          city: string | null;
          country: string | null;
          timezone: string;
      }
      interface UTMParameters {
          utm_source?: string;
          utm_medium?: string;
          utm_campaign?: string;
          utm_content?: string;
          utm_term?: string;
      }
// Get the device type (desktop or mobile)
function getDeviceType(): string {
          return /Mobile|Android|iP(hone|od|ad)/.test(navigator.userAgent) ? 'MOBILE' : 'DESKTOP';
      }
      
      // Placeholder for the device name
      function getDeviceName(): string {
          return 'Unknown'; // Replace this with logic if specific detection is required
      }
      
      // Get the browser name
      function getBrowser(): string {
          const userAgent = navigator.userAgent;
          if (userAgent.includes('Chrome')) return 'chrome';
          if (userAgent.includes('Firefox')) return 'firefox';
          if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) return 'safari';
          return 'other';
      }
      
      // Get the OS type
      function getOSType(): string {
          const platform = navigator.platform.toLowerCase();
          if (platform.includes('win')) return 'windows';
          if (platform.includes('mac')) return 'macos';
          if (platform.includes('linux')) return 'linux';
          if (platform.includes('iphone') || platform.includes('ipad')) return 'ios';
          if (platform.includes('android')) return 'android';
          return 'unknown';
      }
      
      // Get the IP address from an external service
      async function getIPAddress(): Promise<string | null> {
          try {
              // const response = await fetch('https://api.ipify.org?format=json');
              // const data = await response.json();
              // return data.ip;
return  "103.217.246.235"
          } catch (error) {
              console.error('Error fetching IP address:', error);
              return '';
          }
      }
      
      // Get location details (latitude, longitude, city, country)
      async function getLocationDetails(payload: DynamicPayload): Promise<void> {
          if (navigator.geolocation) {
              return new Promise((resolve) => {
                  navigator.geolocation.getCurrentPosition(
                      async (position) => {
                          payload.latitude = position.coords.latitude.toString();
                          payload.longitude = position.coords.longitude.toString();
      
                          // Fetch city and country using a geolocation service
                    //       try {
                    //           const response = await fetch(`https://ip-api.com/json/`);
                    //           const data = await response.json();
                    //           payload.city = data.city;
                    //           payload.country = data.country;
                    //       } catch (error) {
                    //           console.error('Error fetching location details:', error);
                    //       }
      
                          resolve();
                      },
                      (error) => {
                          console.error('Geolocation error:', error);
                          resolve();
                      }
                  );
              });
          }
      }
     export async function createDynamicPayload(): Promise<DynamicPayload> {
          const payload: DynamicPayload = {
              device_type: getDeviceType(),
              device_name: getDeviceName(),
              ip_address: await getIPAddress(),
              browser: getBrowser(),
              os_type: getOSType(),
              latitude: '',
              longitude: '',
              city: '',
              country: '',
              timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          };
      
          // Get location details
        //   await getLocationDetails(payload);
      
          return payload;
      }
      
      export function getUTMParameters(url?: string): UTMParameters {
        // Check if URL is valid
        try {
            const urlToParse = url || window.location.href; // Use the provided URL or current location
    
            // Ensure the URL has a valid structure
            const urlObj = new URL(urlToParse);  // Will throw error if the URL is invalid
            
            // Only process search params if they exist
            const urlParams = urlObj.searchParams;
    
            const utmParams: UTMParameters = {
                utm_source: urlParams.get("utm_source") || undefined,
                utm_medium: urlParams.get("utm_medium") || undefined,
                utm_campaign: urlParams.get("utm_campaign") || undefined,
                utm_content: urlParams.get("utm_content") || undefined,
                utm_term: urlParams.get("utm_term") || undefined,
            };
    
            // Remove undefined keys and return only defined ones
            return Object.fromEntries(
                Object.entries(utmParams).filter(([_, value]) => value !== undefined)
            ) as UTMParameters;
        } catch (error) {
            console.error("Error parsing URL:", error);
            return {}; // Return an empty object if URL parsing fails
        }
    }
    export function getRefferCode(url?: string): string {
        // console.log('hi')
        // Check if URL is valid
        try {
            const urlToParse = url || window.location.href; // Use the provided URL or current location
    
            // Ensure the URL has a valid structure
            const urlObj = new URL(urlToParse);  // Will throw error if the URL is invalid
            
            // Only process search params if they exist
            const urlParams = urlObj.searchParams;
            const refferCode: string =  sessionStorage.getItem("referralCode") ||''
    
            // Remove undefined keys and return only defined ones
         return refferCode
        } catch (error) {
            console.error("Error parsing URL:", error);
            return ''; // Return an empty object if URL parsing fails
        }
    }

      export const userdata=await createDynamicPayload()
